// Phase SA-5 — Bookmaker chips (Stake / Betway / Sportybet / 1xBet / Other).
//
// One-tap selection per brief §4.1. Selected state uses
// .sa-bookmaker-chip[data-selected="true"] (SA-3 CSS — amber-glow
// background + accent border).

import { BOOKMAKER_OPTIONS } from "./legHelpers.ts";

export interface BookmakerChipRowProps {
  value: string | null;
  onChange: (slug: string | null) => void;
}

export function BookmakerChipRow({
  value,
  onChange,
}: BookmakerChipRowProps): JSX.Element {
  return (
    <div
      className="sa-bookmaker-chips"
      role="radiogroup"
      aria-label="Bookmaker"
      data-testid="sa-bookmaker-chip-row"
    >
      {BOOKMAKER_OPTIONS.map((b) => {
        const selected = b.slug === value;
        return (
          <button
            key={b.slug}
            type="button"
            className="sa-bookmaker-chip"
            data-selected={selected || undefined}
            data-testid={`sa-bookmaker-${b.slug}`}
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(selected ? null : b.slug)}
          >
            {b.label}
          </button>
        );
      })}
    </div>
  );
}
